import { AppointmentSchedulerV2 } from "@/Appointments/Components/Scheduling/AppointmentSchedulerV2";
import { PredefinedAppointmentGroup } from "@/Appointments/Models/Scheduling/PredefinedAppointmentGroup";
import { WorkDayV2 } from "@/Appointments/Models/Scheduling/WorkDayV2";
import { SchedulerDisplayMode } from "@/Common/Models/UI/Enums";
import * as LocalPatientOperations from "@/Common/Operations/operations.patient.local";
import { LocalEvent } from "@/Common/Stores/Actions/LocalEvent";
import { IPatientAppointmentModel } from "@/Patient/Models/UI/Appointment/IPatientAppointmentModel";
import { AppointmentFilters } from "./AppointmentFilters";

interface IAppointmentScheduler {
    month: number;
    workDaysV2: Immutable.List<WorkDayV2>;
    displayMode?: SchedulerDisplayMode;
    Model: IPatientAppointmentModel;
    shouldIgnorePublicationRules: boolean;
}

class AppointmentScheduler extends React.Component<IAppointmentScheduler, any> {
    public componentWillUnmount(): void {
        $(window).off("resize.sched");
    }

    public render(): JSX.Element {
        return (
            <div className="basic-scheduler">
                {this.renderHeader()}
                <AppointmentSchedulerV2
                    workDays={this.props.workDaysV2}
                    minorAxisResolutionInMinutes={5}
                    fullWidth={false}
                    showScheduleDate={true}
                    onDivClick={this.openPredefinedAppointmentTimeSlot.bind(this)}
                />
            </div>
        );
    }

    private renderHeader(): JSX.Element {
        return (
            <div className="b-sc-nav">
                <div className="tb sc-nav">
                    <AppointmentFilters
                        model={this.props.Model}
                        asapClick={() => this.asapClick()}
                        shouldIgnorePublishingRules={this.props.shouldIgnorePublicationRules}
                    />
                    <div className="tbc c2">
                        <span style={{ marginRight: "7px" }} className={`toggle-icon${!!this.props.Model.get("IncludeRuleSets") ? " active" : ""}`} onClick={() => this.asapClick(!this.props.Model.get("IncludeRuleSets"))} />
                        <span className="glyphicon glyphicon-menu-left" onClick={this.previous.bind(this)} />
                        <span className="glyphicon glyphicon-menu-right" onClick={this.next.bind(this)} />
                    </div>
                </div>
            </div>
        );
    }

    private asapClick(includeRuleSets: boolean = false): void {
        sessionStore.dispatch(
            LocalPatientOperations.Appointment.AsapClick,
            { includeRuleSets: includeRuleSets }
        );
    }

    private openPredefinedAppointmentTimeSlot(blueRectangle: PredefinedAppointmentGroup): void {
        var operation = new LocalEvent(LocalPatientOperations.Appointment.OpenPredefinedAppointmentTimeSlot);
        operation.AddItem("value", blueRectangle);
        LocalEventDispatcher.dispatch(operation);
    }

    private next(): void {
        LocalEvent.Dispatch(LocalPatientOperations.Appointment.Next);
    }

    private previous(): void {
        LocalEvent.Dispatch(LocalPatientOperations.Appointment.Previous);
    }
}

export { AppointmentScheduler };
